module.exports = __webpack_public_path__ + "static/media/M13ws.f67d6b61.pdf";